import { withExperiments as experimetnsInjector, } from '@wix/wix-experiments-react';
export var withExperiments = function (component) { return experimetnsInjector(component); };
//# sourceMappingURL=with-experiments.js.map